/**
 * Toy Finder Service
 * Handles sending images to TOY_FINDER_URL to identify toys from images
 */

const TOY_FINDER_URL = process.env.REACT_APP_TOY_FINDER_URL;

export const toyFinderService = {
  /**
   * Find toy data from an image
   * @param {File|Blob} imageFile - The image file to send
   * @returns {Promise<Object>} Toy data found from the image
   */
  async findToyFromImage(imageFile) {
    try {
      if (!TOY_FINDER_URL) {
        throw new Error('Toy finder URL is not configured. Please set REACT_APP_TOY_FINDER_URL in your environment variables.');
      }

      if (!imageFile) {
        throw new Error('Image file is required');
      }

      // Create FormData to send the image as binary
      const formData = new FormData();
      formData.append('data', imageFile);

      console.log('Toy Finder - Sending image to:', TOY_FINDER_URL);
      console.log('Toy Finder - Image file:', {
        name: imageFile.name || 'camera-capture',
        type: imageFile.type,
        size: imageFile.size
      });

      // Send the image as binary data
      const response = await fetch(TOY_FINDER_URL, {
        method: 'POST',
        body: formData // No Content-Type header - browser will set it with boundary for FormData
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
      }

      const result = await response.json();
      console.log('Toy Finder - Response:', result);

      return result;
    } catch (error) {
      console.error('Toy Finder - Error:', error);
      throw error;
    }
  }
};

export default toyFinderService;

